import { OrderBlock, OrderLineItem } from 'core/Components';
import { centsToDollar } from 'core/Utils';
import { Card, Divider, Group, ImageMantine, Skeleton, Stack, Text } from 'ui';

import { useShowEntryByProviderId } from '../../../../hooks/queries/Ledger/owner';

const EntryDetailsCard = ({ entryId }: { entryId: string }) => {
  const { data: entryData, isLoading } = useShowEntryByProviderId(entryId);

  return (
    <Card radius={8} p={0} bd="1px solid gray.1">
      <Stack gap={0}>
        <Group p={'md'} bg="gray.0">
          <Skeleton visible={isLoading} w={48}>
            <ImageMantine w={48} src={entryData?.image} radius={12} />
          </Skeleton>
          <Text fz={14} fw={600}>
            <Skeleton visible={isLoading}>{entryData?.title}</Skeleton>
          </Text>
        </Group>
        <Divider />
        <Stack p={'md'}>
          <OrderBlock.Container>
            <OrderLineItem
              label="Total Purchase"
              value={centsToDollar(entryData?.transaction_amount)}
              valueBold
            />
            <OrderLineItem
              label="Cashback Percent"
              value={`${entryData?.cashback_percentage}%`}
              valueBold
            />
            <OrderLineItem
              label="Earned Cashback"
              value={centsToDollar(entryData?.cashback_amount)}
              valueBold
              labelBold
            />
          </OrderBlock.Container>
        </Stack>
      </Stack>
    </Card>
  );
};

export { EntryDetailsCard };
